const csvStringData = [['Name', 'Email'], ['Name Surname', 'example@test.com']].map((row) => row.join(',')).join('\n');

export const downloadStudentListTemplate = () => {
  const blob = new Blob([csvStringData], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'students-list-template.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
